require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.1@core-js/library/modules/es7.symbol.observable.js
// module id = 693
// module chunks = 0